// Brand wordmark. The rame `·` between "InCorpo" and "Sano" is part of the
// brand mark — never substitute or remove it. Optional `sub` flag adds the
// JetBrains Mono "BETA" tag like the prototype's ICSWordmark size > 18 cases.
//
// When `displayName` is supplied and is NOT "InCorpoSano", the component
// renders the tenant's display name as plain text (no copper · split) and
// suppresses the BETA badge — both are ICS-only brand elements.
//
// Ported from handoff_input/design/screens/shared.jsx :: ICSWordmark.

import type { CSSProperties } from "react";

export interface WordmarkProps {
  /** Base font size in px for the serif "InCorpo·Sano" run. Default 18 px
   *  matches the prototype's ICS.size default. The "BETA" sublabel scales
   *  proportionally at 0.55× this value, exactly as in the JSX original. */
  size?: number;
  /** When true renders the small "BETA" mono sublabel on the same baseline.
   *  Silently ignored for non-ICS tenants. */
  sub?: boolean;
  /** Optional override for the main text colour; defaults to `text-ink`. */
  color?: string;
  className?: string;
  /** Tenant display name from useBranding(). When absent or equal to
   *  "InCorpoSano", the component renders the original ICS brand markup
   *  byte-for-byte. Any other value renders the tenant name as plain text
   *  and suppresses the BETA badge. */
  displayName?: string;
}

export function Wordmark({
  size = 18,
  sub = false,
  color,
  className,
  displayName,
}: WordmarkProps) {
  const isICS = !displayName || displayName === "InCorpoSano";
  const subSize = size * 0.55;
  const style: CSSProperties = color ? { color } : {};
  return (
    <div
      className={`flex items-baseline gap-1.5 ${className ?? ""}`}
      style={style}
    >
      <span
        className="font-serif font-medium leading-none text-ink tracking-tighter2"
        style={{ fontSize: size }}
      >
        {isICS ? (
          <>InCorpo<span className="text-rame">·</span>Sano</>
        ) : (
          displayName
        )}
      </span>
      {isICS && sub && (
        <span
          className="font-mono uppercase text-ink-faint tracking-[0.4px] leading-none"
          style={{ fontSize: subSize }}
        >
          beta
        </span>
      )}
    </div>
  );
}
